import { create } from 'zustand';

/**
 * Gallery-safe merchant selection for the cash-deposit flow. Seeded from
 * `cashDepositMock`; StoresPage writes it so CashStoresPage's reel can land
 * on the same merchant the widget would pin.
 */
interface CashDepositState {
  selectedMerchantId: string | null;
  setSelectedMerchantId: (id: string | null) => void;
}

export const useCashDepositStore = create<CashDepositState>((set) => ({
  selectedMerchantId: null,
  setSelectedMerchantId: (selectedMerchantId) => set({ selectedMerchantId }),
}));
